import styled from '@emotion/styled';

export const PageTitle = styled('div')`
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  color: ${({ theme }) => theme.COLORS.WHITE._100};
`;
